import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// components
import { Row, Col, Button,FormGroup, Spinner, Input } from "reactstrap";
import Select from 'react-select'
import { CSVLink  } from "react-csv";

// utils
import { getSessionCookie } from 'utils/cookies';
import { formateDate } from "utils/formats";
import { showMessage } from "utils/message.js";

// api
import relatorio_api from "api/relatorio_api";

export default function RelPendenciaAcumulada({ history }) {

  var session = getSessionCookie();

  const { register, errors,setValue } = useForm({ mode: "onBlur" });
  
  const exportRef = React.useRef(null);
  const exportRef2 = React.useRef(null);

  const [showLoading, setshowLoading] = useState(false);

  useEffect(() => {
    loadOptionsDatasDisponiveis();
  }, []);

  //carrega datas disponíveis
  const [options_datas, set_options_datas] = useState([]);
  const loadOptionsDatasDisponiveis = () => {
    relatorio_api.getDatasProcessadas().then(result => {
          if (result.status !== 200) {
              showMessage("Aviso", result.message, 'error', null);
          }
          else {
              let _datas = [];
              result.data.map((m) => _datas.push({ label: formateDate(m.dataProcessamento), value: m.id, periodoProcessado: m.periodoProcessado }));
              set_options_datas(_datas);
          }
      });
  }

  const [idProcessamento, set_idProcessamento] = useState(null);
  const [mesProcessado, set_mesProcessado] = useState(null);
  
  const handleDataSelecionada = (data) => {

    set_mesProcessado(data.periodoProcessado);
    set_idProcessamento(data.value);
  }

//Pendencias Acumuladas DETALHADO
  const headersExportDetalhado = [
    { label: 'Mes Ano', key: 'mesAno' },
    { label: 'Grupo Econômico', key: 'grupoEconomico' },
    { label: 'Cust Code', key: 'custCode' },
    { label: 'Nick Name', key: 'nickName' },
    { label: 'Status Dre', key: 'statusDre'},
    { label: 'Pendencia', key: 'pendencia' },
    { label: 'Data Implantação', key: 'dataImplantacaoString'},
    { label: 'Data Processamento Dados', key: 'dataProcessamento'}
  ]
  const [csvData2, set_csvData2] = useState([]);
  const handleExportarDetalhado = () => {
    if(idProcessamento == null){
      showMessage("Aviso", "Preencha a data de processamento!", 'error', null);
      return
    }
    setshowLoading(true);
    relatorio_api.getPendenciasAcumuladasDetalhado(idProcessamento).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
          if (result.data.length == 0) {
              showMessage("Aviso", "Não existem dados para os filtros informados", 'error', null);
              return;
          }
          set_csvData2(result.data);
          exportRef2.current.link.click();
      }
    })
  }
//----------------------------------------------------------------------------------------------------------------------------------------

//Pendencias Acumuladas CONSOLIDADO
  const headersExportConsolidado = [
    { label: 'Mes Ano Inicial', key: 'mesAnoInicial' },
    { label: 'Mes Ano Final', key: 'mesAnoFinal' },
    { label: 'Grupo Econômico', key: 'grupoEconomico' },
    { label: 'Qtd PDV', key: 'qtdePdv' },
    { label: 'Qtd PDV c/ Pendencia', key: 'qtdePdvPendencia' },
    { label: 'Status', key: 'statusDRE' },
    { label: 'Data Processamento Dados', key: 'dataProcessamento'}
  ]
  const [csvData, set_csvData] = useState([]);

  const handleExportarConsolidado = () => {
    if(idProcessamento == null){
      showMessage("Aviso", "Preencha a data de processamento!", 'error', null);
      return
    }
    setshowLoading(true);
    relatorio_api.getPendenciasAcumuladasConsolidado(idProcessamento).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
          if (result.data.length == 0) {
              showMessage("Aviso", "Não existem dados para os filtros informados", 'error', null);
              return;
          }
          set_csvData(result.data);
          exportRef.current.link.click();
      }
    })
  }
//----------------------------------------------------------------------------------------------------------------------------------------

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className="content">
        <Row className="mb-4 align-items-end">
            <Col lg="12" md="12" sm="12"><h4 className="mt-0 mb-0">Relatório CSV - Pendencias Acumuladas</h4></Col>
        </Row>
        <Row className="mb-4 align-items-end">
          <Col lg="3" md="6" sm="12">
            <FormGroup>
                <label className="form-control-label">Data Processamento</label>
                <Select
                    name="dataProcessamento"
                    options={options_datas}
                    getOptionLabel={o => o.label}
                    getOptionValue={o => o.value}
                    value={options_datas.filter(f => f.value == idProcessamento)}
                    onChange={(data) => handleDataSelecionada(data)}
                    classNamePrefix="select"
                    placeholder="[ Selecione ]"
                    ref={e => register(
                        { name: "dataProcessamento" },
                        { required: true })
                    }                />
                {errors.dataProcessamento && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
            </FormGroup>
          </Col>
          {mesProcessado != null &&
              <Col lg="3" md="6" sm="12">
              <FormGroup>
                <label className="form-control-label">Mês processado</label>
                <Input className="form-control"
                    autoComplete="off"
                    type="text"
                    name="mesProcessado"
                    value={mesProcessado}
                    disabled= {true}
                    innerRef={register({ required: true })}
                />
                {errors.nome && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
              </FormGroup>
            </Col>
          }
          <Col lg="6" md="6" sm="12" >
            <div style={{textAlign:'right'}}>
              <Button color="success" type="button" onClick={handleExportarDetalhado}><i className="fas fa-download"></i>  Exportar Detalhado</Button>
              {csvData2.length > 0 &&
                <CSVLink data={csvData2} headers={headersExportDetalhado} filename="ApuracaoDREPendenciasAcumuladasDetalhado.csv" target="_blank" ref={exportRef2}></CSVLink>
              }
              <Button color="success" type="button" onClick={handleExportarConsolidado}><i className="fas fa-download"></i>  Exportar Consolidado</Button>
              {csvData.length > 0 &&
                <CSVLink data={csvData} headers={headersExportConsolidado} filename="ApuracaoDREPendenciasConsolidado.csv" target="_blank" ref={exportRef}></CSVLink>
              }
            </div>
          </Col> 
        </Row>
      </div>
    </>

  );
}